import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useRef } from 'react';
import scrollTo from 'commons/scrollTo';
import poll from 'commons/poll';
import isClient from 'commons/isClient';
import { times } from 'lodash';
const useProductListingRestoreScrollPosition = t0 => {
  const $ = _c(13);
  const {
    isLoadingComplete,
    loadAllProducts,
    loadMoreProducts,
    previousLastProductPath,
    previousLoadMoreClickCount,
    previousScrollPosition,
    setHasScrollPositionBeenRestored,
    skip: t1,
    action
  } = t0;
  const skip = t1 === undefined ? false : t1;
  const hasRestoredRef = useRef(false);
  let t2;
  if ($[0] !== action || $[1] !== loadAllProducts || $[2] !== loadMoreProducts || $[3] !== previousLastProductPath || $[4] !== previousLoadMoreClickCount || $[5] !== previousScrollPosition || $[6] !== setHasScrollPositionBeenRestored) {
    t2 = () => {
      if (hasRestoredRef.current) {
        return;
      }
      hasRestoredRef.current = true;
      const shouldShowAllProducts = previousLoadMoreClickCount === -1;
      if (shouldShowAllProducts) {
        loadAllProducts();
      } else {
        if (previousLoadMoreClickCount > 0) {
          times(previousLoadMoreClickCount, loadMoreProducts);
        }
      }
      if (previousScrollPosition > 0) {
        poll({
          condition: () => isClient() && !!previousLastProductPath && !!document.querySelector(`[data-xc='product-grid'] [href^='${previousLastProductPath}']`) && action !== "PUSH",
          interval: 25,
          maxRetries: shouldShowAllProducts ? 400 : 100,
          callback: () => {
            scrollTo({
              top: previousScrollPosition,
              behavior: "smooth"
            });
            setHasScrollPositionBeenRestored(true);
          },
          errorCallback: () => {
            setHasScrollPositionBeenRestored(true);
          }
        });
      } else {
        setHasScrollPositionBeenRestored(true);
      }
    };
    $[0] = action;
    $[1] = loadAllProducts;
    $[2] = loadMoreProducts;
    $[3] = previousLastProductPath;
    $[4] = previousLoadMoreClickCount;
    $[5] = previousScrollPosition;
    $[6] = setHasScrollPositionBeenRestored;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const restoreScrollPosition = t2;
  let t3;
  let t4;
  if ($[8] !== isLoadingComplete || $[9] !== restoreScrollPosition || $[10] !== skip) {
    t3 = () => {
      if (skip || hasRestoredRef.current) {
        return;
      }
      if (isLoadingComplete) {
        restoreScrollPosition();
      }
    };
    t4 = [isLoadingComplete, restoreScrollPosition, skip];
    $[8] = isLoadingComplete;
    $[9] = restoreScrollPosition;
    $[10] = skip;
    $[11] = t3;
    $[12] = t4;
  } else {
    t3 = $[11];
    t4 = $[12];
  }
  useEffect(t3, t4);
};
export default useProductListingRestoreScrollPosition;